import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/crewmember/')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/technicians' });
  },
  component: () => null,
});
